 import * as Types from './navActionTypes.js'

const initialState = {
    smart:"PRODUCTION",
    showActiveLines:false
};

export default function nav(state = initialState, action) {
    switch (action.type) {
        case Types.SET_SMART:
            if (state.smart !== action.smart) {
                return Object.assign({}, state, { smart: action.smart });
            }
            return state;
            case Types.SET_SHOWACTIVELINES:
                if (state.showActiveLines !== action.showActiveLines) {
                    return Object.assign({}, state, { showActiveLines: action.showActiveLines });
                }
                return state;
        default:
            return state;
    }
}